/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Criteria } from './Criteria';
import {
    CriteriaFromJSON,
    CriteriaFromJSONTyped,
    CriteriaToJSON,
    CriteriaToJSONTyped,
} from './Criteria';

/**
 * 
 * @export
 * @interface CreateCriteria201Response
 */
export interface CreateCriteria201Response {
    /**
     * 
     */
    data?: Criteria;
}

/**
 * Check if a given object implements the CreateCriteria201Response interface.
 */
export function instanceOfCreateCriteria201Response(value: object): value is CreateCriteria201Response {
    return true;
}

export function CreateCriteria201ResponseFromJSON(json: any): CreateCriteria201Response {
    return CreateCriteria201ResponseFromJSONTyped(json, false);
}

export function CreateCriteria201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCriteria201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : CriteriaFromJSON(json['data']),
    };
}

export function CreateCriteria201ResponseToJSON(json: any): CreateCriteria201Response {
    return CreateCriteria201ResponseToJSONTyped(json, false);
}

export function CreateCriteria201ResponseToJSONTyped(value?: CreateCriteria201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': CriteriaToJSON(value['data']),
    };
}

